// Format any ISO datetime string in IST (India Standard Time) regardless of
// the viewer's browser timezone. Used across the Admin dashboard so the owner
// (in India) always sees Indian wall-clock time — never the server-stored UTC.

const IST = { timeZone: "Asia/Kolkata" };

const FULL_OPTS  = { ...IST, day: "2-digit", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
const SHORT_OPTS = { ...IST, day: "2-digit", month: "short", hour: "numeric", minute: "2-digit", hour12: true };
const DATE_OPTS  = { ...IST, day: "2-digit", month: "short", year: "numeric" };

function _fmt(iso, opts) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return new Intl.DateTimeFormat("en-IN", opts).format(d);
}

// "14 Feb, 10:54 PM" — compact form for dense admin rows
export function fmtIST(iso) { return _fmt(iso, SHORT_OPTS); }

// "14 Feb 2026, 10:54 PM" — full form with year
export function fmtISTFull(iso) { return _fmt(iso, FULL_OPTS); }

// "14 Feb 2026" — date only
export function fmtISTDate(iso) { return _fmt(iso, DATE_OPTS); }
